import { RadioInputSelected, RadioInputUnselectedBig } from '@va/icons';
import { TestAttributes } from '@va/types/component';
import { ElementType } from 'react';
import { Button, ButtonShapes } from '../button/Button';
import { ParagraphWithTooltip, fontWeights, paragraphSizes } from '../typography';

export const InteractiveRadioOption = ({
  icon: Icon,
  primaryLabel,
  secondaryLabel,
  interactiveLabel,
  isSelected,
  onClick,
  ...rest
}: {
  icon: ElementType;
  primaryLabel: string;
  secondaryLabel: string;
  interactiveLabel: string;
  onInteractiveLabelClick: () => void;
  isSelected: boolean;
  onClick: () => void;
} & TestAttributes) => {
  return (
    <li
      data-testid={rest['data-testid']}
      className='flex gap-3 items-center hover:bg-white-snow cursor-pointer rounded-18 py-3 pl-3 pr-6 group'
      onClick={onClick}
    >
      <Button shape={ButtonShapes.circle} color='quaternary' icon={() => <Icon />} />
      <div className='grow overflow-hidden'>
        <ParagraphWithTooltip weight={fontWeights.medium} colorClassName='text-gray-charcoal'>
          {primaryLabel}
        </ParagraphWithTooltip>
        <ParagraphWithTooltip size={paragraphSizes.tiny} colorClassName='text-gray-devil'>
          {secondaryLabel}
        </ParagraphWithTooltip>
        <ParagraphWithTooltip size={paragraphSizes.tiny} colorClassName='text-primary'>
          {interactiveLabel}
        </ParagraphWithTooltip>
      </div>

      {isSelected ? <RadioInputSelected /> : <RadioInputUnselectedBig />}
    </li>
  );
};
